export const LOADING_PRODUCTS = 'LOADING_PRODUCTS ';
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const FILTER_PRODUCTS = 'FILTER_PRODUCTS';
export const GET_PRODUCT_DETAILS = 'GET_PRODUCT_DETAILS';
export const GET_PRODUCT_OPTIONS = 'GET_PRODUCT_OPTIONS';